module.exports = __webpack_public_path__ + "img/profile-image.05cfa354.png";